module.exports = __webpack_public_path__ + "static/simufact01-82d4a75b459e46f2258025b7e9a86b8e.png";